<template>
  <div class="describe">
    

    <div class="body2">
      <img src="@/assets/home3.png" class="img" />
      <div class="text">
        <div class="t1">Comprobación de elegibilidad en tiempo real</div>
        <div class="t2">
         Con nuestro avanzado sistema automatizado, la
aprobación de tu préstamo se procesa en cuestión de
segundos, lo que te permitirá saber de forma instantánea
si eres elegible para solicitar un préstamo de hasta $2,000,000.
        </div>
       
      </div>
    </div>
     <div class="body2 mg">
     
      <div class="text">
        <div class="t1">Depósito en cualquier hora del día</div>
        <div class="t2">
         Nuestro sistema de transferencias de dinero está diseñado para brindarte una experiencia sin interrupciones, disponible 24/7.
        </div>
        <div class="t2">
         Con la confianza de saber que nuestro sistema siempre está disponible, puedes estar seguro de que podemos satisfacer tus necesidades bancarias en cualquier momento del día o de la noche.
        </div>
        
      </div>
       <img src="@/assets/home4.png" class="img" />
    </div>
     <div class="body2">
      <img src="@/assets/home5.png" class="img" />
      <div class="text">
        <div class="t1">Nuestro proceso de préstamo es rápido y sencillo</div>
        <div class="t2">
         Nuestra solicitud de transferencia de dinero se puede completar en línea, desde la comodidad de tu hogar o cualquier otro lugar en el que te encuentres, y solo lleva unos minutos de tu tiempo.
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "describeView",
    data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style scoped lang="scss">
@media (min-width: 680px) {
.describe {
  padding: 80px 0;
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;

.mg{
  margin:  100px 0;
}
  .body2 {
    display: flex;
  
    justify-content: space-around;
    .img {
      width: 345px;
      object-fit:contain;
    }
    .text {
      width: 368px;
      .t1 {
        font-weight: normal;
        font-size: 32px;
        color: #19191a;
        line-height: 47px;
        text-align: left;
        margin-bottom: 24px;
      }
      .t2 {
        font-weight: 400;
        font-size: 15px;
        color: #595959;
        line-height: 21px;
        text-align: left;
        margin-bottom: 15px;
      }
    }
  }
}
}
@media only screen and (max-width: 680px) {
  .describe {
  padding: 80px 0;
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;

.mg{
  margin:  50px 0;
}
  .body2 {
    display: flex;

    justify-content: space-around;
   padding: 0 10px;
    align-items: center;
    .img {
     width: 30%;
    }
    .text {
    width: 60%;
      .t1 {
        font-weight: normal;
        font-size: 16px;
        color: #19191a;
       
        text-align: left;
        margin-bottom: 10px;
      }
      .t2 {
        font-weight: 400;
        font-size: 12px;
        color: #595959;
        
        text-align: left;
        margin-bottom: 6px;
      }
    }
  }
}
}
</style>
